import PropTypes from 'prop-types'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import convertNewSizeToOldSize from './utils'

const TableHeader = ({
  childClassName,
  className,
  customHeaderWidth,
  isNewSizeFlag,
  t,
  titleKey,
  title,
}) => {
  const titleText = hasLocizeTranslation(t, titleKey, title)
  const getChildKey = (row) => (isNewSizeFlag ? `oldsize_${row}` : row)
  const getChild = (row) =>
    isNewSizeFlag ? convertNewSizeToOldSize(row.toLowerCase()) : row
  const isSpecialText = titleText?.indexOf('x') >= 0
  const isHyphen = titleText?.indexOf('-') >= 0
  const hyphepStyle = isHyphen ? { minWidth: 40 } : null
  const styles = customHeaderWidth
    ? {
        width: customHeaderWidth,
      }
    : null

  return (
    <th className={className} key={title} style={styles}>
      {!isSpecialText &&
        titleText.split(' ').map((row) => (
          <div
            className={childClassName}
            style={hyphepStyle}
            key={getChildKey(row)}
          >
            {getChild(row)}
          </div>
        ))}
      {isSpecialText && (
        <div
          className={childClassName}
          style={hyphepStyle}
          key={getChildKey('sp')}
        >
          {titleText}
        </div>
      )}
    </th>
  )
}

TableHeader.propTypes = {
  childClassName: PropTypes.string,
  className: PropTypes.string,
  customHeaderWidth: PropTypes.number,
  isNewSizeFlag: PropTypes.bool,
  t: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
  title: PropTypes.string.isRequired,
}

TableHeader.defaultProps = {
  className: '',
  childClassName: '',
  customHeaderWidth: undefined,
  isNewSizeFlag: false,
  titleKey: '',
}

export default withI18next()(TableHeader)
